import type { RouteObject } from 'react-router'

import { AccessReviewPage } from '@/features/access/AccessReviewPage'

export const routes: RouteObject[] = [{ path: 'access-review', element: <AccessReviewPage /> }]
